export const id = {
  playerProfile: "Player Profile",
  players: "Players",
  username: "Username",
  mobile: "Mobile",
  bank: "Bank",
  accountNumber: "Account Number",
  applicationDate: "Application Date",
  currentLoyaltyPoints: "Current Loyalty Points",
  currentRedemptionLimitPerDay: "Current Redemption Limit Per Day",
  affiliateDashboard: "Affiliate Dashboard",
  suspend: "Suspend",
  activate: "Activate",
  points: "Points",
  editBankAcount: "Edit Bank Account",
  editBankAccount: "Edit Bank Account",
  editBankAcountV2: "Edit Bank Account V2",
  forceEditBankAcountV2: "Force Edit Bank Account V2",
  selectBank: "Select Bank",
  cancel: "cancel",
  saveBankAccount: "Save Bank Account",
  updateUsername: "Update Username",
  userId: "User ID",
  currentUsername: "Current Username",
  newUsername: "New Username",
  requestUpdate: "Request Update",
  changePassword: "Change Password",
  newPassword: "New Password",
  savePassword: "Save Password",
  manualDeposit: "Manual Deposit",
  manualDepositV2: "Manual DepositV2",
  manualWithdraw: "Manual Withdraw (MANUAL)",
  manualWithdrawV2: "Manual WithdrawV2",
  manualPaymentDeposit: "Manual Payment Deposit",
  deposit: "Deposit",
  manualTopupPoint: "Manual Topup Point",
  manualTopupLoyaltyPoint: "Manual Topup Loyalty Point",
  topup: "Topup",
  walletInfo: "Wallet Info",
  affiliateInfo: "Affiliate Info",
  topupWithdrawRecords: "Topup/Withdraw Records",
  gameRecords: "Game Records",
  playerConfig: "Player Config",
  playerConfigV2: "Player Config V2",
  playerLogin: "Player Login",
  commissionInfo: "Commission Info",
  loyaltyInfo: "Loyalty info",
  updateRedemptionLimit: "Update Redemption Limit",
  selectTab: "Select a Tab",
  thisUserSuspended: "This user has been suspended",
  suspend: "Suspend",
  activate: "Activate",
  ok: "ok",
  depositDate: "Deposit Date",
  withdrawDate: "Withdraw Date",
  deposit: "Deposit",
  updateRedemptionCountLimit: " Update Redemption Count Limit Per Day",
  redemptionLimitPerDay: "Redemption Limit Per Day",
  close: "Close",
  update: "Update",
  id: "Id",
  name: "Name",
  phoneNumber: "Phone Number",
  confirm: "Confirm",
  quest: "Quest",
  accountName: "Account Name",
  qrDeposit: "QR Deposit",
  reason: "Reason",
  suspendedBy: "ถูกระงับการใช้งานโดย",
  dueTo: "เนื่องจาก",
  createTicket: "สร้างตั๋ว",
  forceEditBankAccount: 'Force Edit Bank Account',
  userTransactionSummaries: 'User Transaction Summaries',
};
